import type { Doc } from "building-types/doc";
import type { ViewTemplateOverride } from "building-types/views/planSets";
import { sortEntitiesBySortIndex } from "common/utils/sortIndex";

export function docGetSortedViewTemplateOverrides(
  doc: Pick<Doc, "viewTemplateOverrides">,
  overrideIds: string[],
): ViewTemplateOverride[] {
  const vtos: ViewTemplateOverride[] = [];

  for (const id of overrideIds) {
    if (doc.viewTemplateOverrides[id]) {
      vtos.push(doc.viewTemplateOverrides[id]);
    }
  }

  return sortEntitiesBySortIndex(vtos);
}
